module.exports = __webpack_public_path__ + "static/media/selection-bg-2.97050688.svg";